module.exports = __webpack_public_path__ + "assets/767d27ed953500e66a496555107d765e.png";